import { AiProviderEnum } from 'stores';

interface AiModelProviderConfigInterface {
    provider: number,
    name: string
}

function getProviderConfigs(): Array<AiModelProviderConfigInterface> {
    return [
        {
            provider: AiProviderEnum.SCALEWAY,
            name: 'Scaleway'
        }
    ];
}

export function getAiModelProviderOptions() {
    return getProviderConfigs().map((config) => ({
        value: config.provider,
        name: config.name
    }));
}

export function getAiModelProviderName(provider: number) {
    const config = getProviderConfigs().find((item) => item.provider === provider);
    return config ? config.name : `Provider ${provider}`;
}
